// extracted by mini-css-extract-plugin
module.exports = {"featureNotice":"_1d8Av","content":"_2mFEp","footer":"hSU7N"};